/**
 * @generated SignedSource<<710b177663db95a131a55e1fae450fb6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EntityAvatarFragment$data = {
  readonly displayName: string;
  readonly username: string;
  readonly " $fragmentSpreads": FragmentRefs<"EntityProfilePicFragment">;
  readonly " $fragmentType": "EntityAvatarFragment";
};
export type EntityAvatarFragment$key = {
  readonly " $data"?: EntityAvatarFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EntityAvatarFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EntityAvatarFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "thumbnail",
          "value": true
        }
      ],
      "kind": "FragmentSpread",
      "name": "EntityProfilePicFragment"
    }
  ],
  "type": "Entity",
  "abstractKey": "__isEntity"
};

(node as any).hash = "1f93886d568e40644d88850dd4752230";

export default node;
